let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7jeqD"), load("2nh75"), load("5jCVU")]).then(() => parcelRequire('4ebXC'));